import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConsumerListingPanelComponent from './consumerListingPanel.component'
import EditLoyaltyPointDialogContainer from "../../../components/dialog/editLoyaltyPointDialog";
import { fetchConsumerListing } from 'modules/consumer/redux/action/consumer.action'
import { selectLoading } from 'modules/notification'
import { generatePaginationOptions } from "lib/helper";

export default function ConsumerListingPanelContainer() {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(25)
    const [search, setSearch] = useState("")
    const [searchType, setSearchType] = useState(0)
    const [dateRange, setDateRange] = useState(null)
    const [paginationOptions, setPaginationOptions] = useState([]);
    const dispatch = useDispatch()
    const totalRecords = useSelector(state => state.consumer.consumerList.totalRecords)
    const consumers = useSelector(state => state.consumer.consumerList.data)
    const customField = useSelector(state => state.consumer.consumerList.customField)
    const isFetching = useSelector(state => selectLoading(state, fetchConsumerListing.typePrefix))
    const [consumerDetails, setConsumerDetails] = useState({});
    const [isEditLoyaltyPointDialogOpen, setIsEditLoyaltyPointDialogOpen] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(event.target.value)
    };

    const handleSearch = (searchValue, searchColumn, dateRangeValue) => {
        setPage(0);
        setSearch(searchValue);
        setSearchType(searchColumn);
        setDateRange(dateRangeValue);
    };

    useEffect(() => {
        const params = {
            length: rowsPerPage,
            start: rowsPerPage * page,
            search: search,
            searchType: searchType
        };
        if (dateRange && dateRange.from && dateRange.to) {
            params.startDate = dateRange.from;
            params.endDate = dateRange.to;
        }

        dispatch(fetchConsumerListing(params))
    }, [rowsPerPage, page, search, searchType, dateRange, dispatch])

    useEffect(() => {
        setPaginationOptions(generatePaginationOptions(totalRecords))
    }, [totalRecords])

    const handleReload = () => {
        const params = {
            length: rowsPerPage,
            start: rowsPerPage * page,
            search: search,
            searchType: searchType
        };
        if (dateRange && dateRange.from && dateRange.to) {
            params.startDate = dateRange.from;
            params.endDate = dateRange.to;
        }

        dispatch(fetchConsumerListing(params));
    };

    const handleEditLoyaltyPoint = ({ item }) => {
        setConsumerDetails(item);
        setIsEditLoyaltyPointDialogOpen(true);
    };

    return (
        <>
            <ConsumerListingPanelComponent
                consumers={consumers}
                customField={customField}
                isFetching={isFetching}
                page={page}
                search={search}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRecords}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSearch={handleSearch}
                handleReload={handleReload}
                paginationOptions={paginationOptions}
                handleEditLoyaltyPoint={handleEditLoyaltyPoint}
            />
            <EditLoyaltyPointDialogContainer
                isOpen={isEditLoyaltyPointDialogOpen}
                handleClose={() => setIsEditLoyaltyPointDialogOpen(false)}
                consumerDetails={consumerDetails}
                handleReload={handleReload}
            />
        </>
    )
}
